import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  type?: 'button' | 'submit' | 'reset';
}

const Button = ({ children, onClick, variant = 'primary', type = 'button' }: ButtonProps) => {

  const baseStyles = 'px-[26px] py-[13px] w-80 rounded-lg font-semibold transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2';

  const primaryStyles = 'bg-black text-white hover:bg-gray-700 ';

  const secondaryStyles = 'bg-white text-gray-800 border border-gray-300 hover:bg-gray-50';

  const combinedStyles = `${baseStyles} ${variant === 'primary' ? primaryStyles : secondaryStyles}`;

  return (
    <button
      type={type}
      onClick={onClick} // Corrected line
      className={combinedStyles}
    >
      {children}
    </button>
  );
};

export default Button;

